// extracted by mini-css-extract-plugin
module.exports = {"sortBox":"sortsHeader_sortBox__2h0z7","link":"sortsHeader_link__2q_n9","active":"sortsHeader_active__3LsXI"};